let alertAudio = null;

const ALERT_SOUND_URL = "/sounds/exgold_alert.wav";

/** Play the bundled ~5s "money received" alert for in-app notifications. */
export function playNotificationSound() {
  try {
    if (!alertAudio) {
      alertAudio = new Audio(ALERT_SOUND_URL);
      alertAudio.preload = "auto";
    }
    alertAudio.currentTime = 0;
    alertAudio.volume = 0.85;
    alertAudio.play().catch(() => {});
  } catch {
    // Audio not supported or autoplay blocked
  }
}
